import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "supportsDarkMode", "children", "isDark", "toggleTheme", "user", "initialRoute", "source", "onChangeRoute", "isSidebarV2Enabled"];
import cn from "clsx";
import styled from "styled-components";
import { NewDashboardContextProvider } from "./context";
import { jsx as _jsx } from "react/jsx-runtime";
var Wrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-xzndc3-0"
})(["\n  scroll-behavior: smooth;\n  -webkit-overflow-scrolling: touch;\n  transition: ", ";\n  ", " {\n    overflow: hidden;\n  }\n"], function (_ref) {
  var theme = _ref.theme;
  return theme.transition('background-color');
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up('sm');
});
var NewDashboardRoot = function NewDashboardRoot(_ref3) {
  var className = _ref3.className,
    supportsDarkMode = _ref3.supportsDarkMode,
    children = _ref3.children,
    isDark = _ref3.isDark,
    toggleTheme = _ref3.toggleTheme,
    user = _ref3.user,
    initialRoute = _ref3.initialRoute,
    source = _ref3.source,
    onChangeRoute = _ref3.onChangeRoute,
    _ref3$isSidebarV2Enab = _ref3.isSidebarV2Enabled,
    isSidebarV2Enabled = _ref3$isSidebarV2Enab === void 0 ? false : _ref3$isSidebarV2Enab,
    rest = _objectWithoutProperties(_ref3, _excluded);
  var dark = supportsDarkMode && isDark;
  if (isSidebarV2Enabled) {
    return /*#__PURE__*/_jsx(NewDashboardContextProvider, {
      user: user,
      isDark: dark,
      source: source,
      toggleTheme: toggleTheme,
      initialRoute: initialRoute,
      onRouteChange: onChangeRoute,
      children: children
    });
  }
  return /*#__PURE__*/_jsx(NewDashboardContextProvider, {
    user: user,
    isDark: dark,
    source: source,
    toggleTheme: toggleTheme,
    initialRoute: initialRoute,
    onRouteChange: onChangeRoute,
    children: /*#__PURE__*/_jsx(Wrapper, _objectSpread(_objectSpread({
      className: cn('relative w-full min-h-screen sm:h-screen sm:flex', dark ? 'bg-base-dark text-white' : 'bg-gray-lighter text-base-main', className)
    }, rest), {}, {
      children: children
    }))
  });
};
export default NewDashboardRoot;